/*
 * Copyright (c) 2025. World Wide Generation Ltd
 */

export const safeJsonParse = <T>(jsonString: string | null | undefined, fallback: T): T => {
  if (!jsonString) {
    return fallback;
  }
  try {
    const parsed = JSON.parse(jsonString);
    return parsed === null ? fallback : parsed;
  } catch (error) {
    console.error('Failed to parse JSON string:', error);
    return fallback;
  }
};
